import Location from '../../components/Location/Location';

function LocationPage() {
  return <Location />;
}

export default LocationPage;
